import { useState, useCallback } from 'react';
import { UploadProgress } from '../../../../../../../services/signalRService';

/**
 * Hook for managing Grouper upload progress state
 */
export function useGrouperUpload() {
  const [uploadProgress, setUploadProgress] = useState<UploadProgress | null>(null);
  const [isUploadInProgress, setIsUploadInProgress] = useState(false);

  const onProgress = useCallback((progress: UploadProgress) => {
    setUploadProgress(progress);
  }, []);

  const onCompleted = useCallback((progress: UploadProgress) => {
    setUploadProgress(progress);
    setIsUploadInProgress(false);
  }, []);

  const onError = useCallback((progress: UploadProgress) => {
    setUploadProgress(progress);
    setIsUploadInProgress(false);
  }, []);

  const handleCloseProgressDialog = useCallback(() => {
    setUploadProgress(null);
    setIsUploadInProgress(false);
  }, []);

  const handleStartUpload = useCallback(() => {
    setIsUploadInProgress(true);
    // Set initial progress state so dialog shows immediately
    setUploadProgress({
      operationId: '',
      progressPercentage: 0,
      message: 'Starting upload...',
      processedRecords: 0,
      totalRecords: 0,
      timestamp: new Date().toISOString(),
      status: 'Starting',
      uploadType: 'Grouper'
    });
  }, []);

  return {
    uploadProgress,
    isUploadInProgress,
    onProgress,
    onCompleted,
    onError,
    handleCloseProgressDialog,
    handleStartUpload,
  };
}
